import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=642ee219&scoped=true"
import script from "./Sorter.vue?vue&type=script&lang=ts"
export * from "./Sorter.vue?vue&type=script&lang=ts"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=642ee219&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ee219",
  null
  
)

export default component.exports